import { render, staticRenderFns } from "./InternalChatLog.vue?vue&type=template&id=2bf151ba"
import script from "./InternalChatLog.vue?vue&type=script&lang=js"
export * from "./InternalChatLog.vue?vue&type=script&lang=js"
import style0 from "./InternalChatLog.vue?vue&type=style&index=0&id=2bf151ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports